var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-table",
    {
      ref: "table",
      attrs: {
        title: "위험형태 목록",
        tableId: "riskType",
        columns: _vm.grid.columns,
        data: _vm.grid.data,
        gridHeight: _vm.grid.height,
        filtering: false,
        columnSetting: false,
        usePaging: false,
        selection: _vm.popupParam.type,
        rowKey: "ramRiskTypeId",
      },
      on: { rowDblclick: _vm.rowDblclick },
    },
    [
      _c(
        "template",
        { slot: "table-button" },
        [
          _c(
            "q-btn-group",
            { attrs: { outline: "" } },
            [
              _vm.editable
                ? _c("c-btn", {
                    attrs: { label: "LBLSELECT", icon: "check" },
                    on: { btnClicked: _vm.select },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }